import { Children, ReactElement } from 'react';
import { Stack, StackItem, Container, SpacingToken } from '@optimus-web/core';

interface WidgetCardsWrapperProps {
    children: ReactElement | ReactElement[];
    cardMaxWidth?: string;
    padding?:
        | SpacingToken
        | [SpacingToken, SpacingToken]
        | [SpacingToken, SpacingToken, SpacingToken]
        | [SpacingToken, SpacingToken, SpacingToken, SpacingToken];
}

export const WidgetCardsWrapper = ({ children, cardMaxWidth, padding }: WidgetCardsWrapperProps) => (
    <Container padding={padding || '300'} data-test-id="highlights-ledgers">
        <Stack
            spacing="200"
            distribution="stretch"
            tabletMax={{
                vertical: true,
            }}
        >
            {Children.map(children, (child) => (
                <StackItem key={child.props.title} desktopUp={{ maxWidth: cardMaxWidth }}>
                    {child}
                </StackItem>
            ))}
        </Stack>
    </Container>
);
